import { Router, UrlTree } from '@angular/router';
import { UserState } from '@lbmx/types';
import { Observable, of } from 'rxjs';
import { SESSION_SETUP_ROUTE } from '../session/session.service';

export default function checkMarketplace(
  userState: UserState,
  config: { url: string; router: Router },
): Observable<boolean | UrlTree> {
  const { marketplace, marketplaces } = userState;
  return marketplace &&
    marketplaces instanceof Array &&
    marketplaces?.map((m) => m.accountKey.toString()).includes(marketplace)
    ? of(true)
    : of(
        (() => {
          const urlTree = config.router.parseUrl(SESSION_SETUP_ROUTE);
          const parsed = config.router.parseUrl(config.url);
          const nextUrl =
            parsed.root.children.primary?.segments
              .map((s) => s.path)
              .join('/') ?? '/';
          urlTree.queryParams = {
            ...parsed.queryParams,
            ['nextUrl']: encodeURIComponent(nextUrl),
          };
          return urlTree;
        })(),
      );
}
